import { type Meta } from '../types/docs';
import {
  AUTOMATION_RUN_SESSION_OPENED_LOCATIONS,
  AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM,
  AUTOMATIONS_ANALYTICS_RUN_STATUSES,
} from './automationsAnalytics';

const META: Meta = {
  description: 'The user opens an agent thread session from an automation run',
  name: 'automation_run_session_opened',
  params: [
    AUTOMATIONS_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'The automation that produced the run',
      name: 'automation_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Status of the run when the session was opened',
      name: 'run_status',
      required: true,
      type: 'enum',
      values: [...AUTOMATIONS_ANALYTICS_RUN_STATUSES],
    },
    {
      description: 'Where the run session was opened from',
      name: 'location',
      required: true,
      type: 'enum',
      values: [...AUTOMATION_RUN_SESSION_OPENED_LOCATIONS],
    },
  ],
};

export default META;
